<template>
  <div class="enkai__searchLinks__accordions">
    <h2 class="enkai__searchLinks__accordions__header">条件を指定して{{ prefectureName }}のお店を探す</h2>
    <div class="enkai__searchLinks__accordions__container">
      <div class="title">
        <span>エリアで絞る</span>
        <i class="dropdown icon"></i>
      </div>
      <div class="content">
        <template v-if="areaDetail">
          <a v-for="station in this.stationOptions" :key="station.value" :href="`/${prefectureNameEn}/A${station.area}/AD${station.area_detail}/S${station.value}/`">
            {{ station.label }}
          </a>
        </template>
        <template v-else-if="area">
          <a v-for="areaDetail in this.areaDetailOptions" :key="areaDetail.value" :href="`/${prefectureNameEn}/A${areaDetail.area}/AD${areaDetail.value}/`">
            {{ areaDetail.label }}
          </a>
        </template>
        <template v-else>
          <a v-for="area in areaOptions" :key="area.value" :href="`/${prefectureNameEn}/A${area.value}/`">
            {{ area.label }}
          </a>
        </template>
      </div>
    </div>
    <div class="enkai__searchLinks__accordions__container">
      <div class="title">
        <span>人数で絞る</span>
        <i class="dropdown icon"></i>
      </div>
      <div class="content">
        <a v-for="peopleSearchLink in peopleSearchLinks" :key="peopleSearchLink.text" :href="peopleSearchLink.url">
          {{ peopleSearchLink.text }}
        </a>
      </div>
    </div>
    <div class="enkai__searchLinks__accordions__container">
      <div class="title">
        <span>シーン別で絞る</span>
        <i class="dropdown icon"></i>
      </div>
      <div class="content">
        <a v-for="sceneSearchLink in sceneSearchLinks" :key="sceneSearchLink.text" :href="sceneSearchLink.url">
          {{ sceneSearchLink.text }}
        </a>
      </div>
    </div>
    <div class="enkai__searchLinks__accordions__container">
      <div class="title">
        <span>会場タイプで絞る</span>
        <i class="dropdown icon"></i>
      </div>
      <div class="content">
        <a v-for="shopTypeSearchLink in shopTypeSearchLinks" :key="shopTypeSearchLink.text" :href="shopTypeSearchLink.url">
          {{ shopTypeSearchLink.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
      prefectureName: {
          type: String,
          required: true,
      },
      prefectureNameEn: {
          type: String,
          required: true,
      },
      area: {
          type: Number,
          required: false
      },
      areaDetail: {
          type: Number,
          required: false
      },
      station: {
          type: Number,
          required: false
      },
  },
  data() {
    return {
        peopleSearchLinks: [],
        sceneSearchLinks: [],
        shopTypeSearchLinks: [],
        areas: [],
        areaDetails: [],
        stations: [],
        areaOptions: [],
        areaDetailOptions: [],
        stationOptions: [],
    };
  },
  created() {
      this.generateAreaSearchLinks();
      this.generatePeopleSearchLinks();
      this.generateSceneSearchLinks();
      this.generateShopTypeSearchLinks();
  },
  methods: {
      generatePeopleSearchLinks() {
          const baseUrl = this.createBaseUrl();
          const counts = [20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 300, 500];
          counts.forEach((count) => {
              this.peopleSearchLinks.push({
                  url: `${baseUrl}${count}people/`,
                  text: `${count}人以上の宴会・パーティーが可能なお店`
              });
          });
      },
      generateSceneSearchLinks() {
          const label = {
              'enkai': '忘年会・新年会',
              'konshinkai': '懇親会・パーティー',
              'kansoukai': '歓迎会・送別会',
              'party': '企業パーティー',
              'shaonkai': '謝恩会',
              'dousoukai': '同窓会',
              'nijikai': '二次会',
              'wedding_nijikai': '結婚式二次会'
          }
          const baseUrl = this.createBaseUrl();
          Object.keys(label).forEach((key) => {
              this.sceneSearchLinks.push({
                  url: `${baseUrl}${key}/`,
                  text: `${label[key]}`
              });
          });
      },
      generateShopTypeSearchLinks() {
          const label = {
              'izakaya': '居酒屋',
              'restaurant_cafe': 'レストラン/カフェ',
              'hotel_banquet': 'ホテル/宴会場',
              'party_space': 'パーティースペース',
              'wedding': '結婚式場（ウェディング）',
              'guesthouse_ceremony': 'ゲストハウス・式場',
              'club': 'クラブ',
              'meeting_room': '会議室',
              'sonota': 'その他会場',
          }
          const baseUrl = this.createBaseUrl();
          Object.keys(label).forEach((key) => {
              this.shopTypeSearchLinks.push({
                  url: `${baseUrl}${key}/`,
                  text: `${label[key]}`
              });
          });
      },
      generateAreaSearchLinks() {
          this.createForm().get('/api/areas/', function(response) {
              _.forEach(response.data, function(each) {
                  this.areas.push(each);
              }.bind(this));
              const selectedPrefecture = this.prefectureNameEn
              this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
          });
          this.createForm().get('/api/area_details/', function(response) {
              _.forEach(response.data, function(each) {
                  this.areaDetails.push(each);
              }.bind(this));
              const selectedArea = this.area;
              if (selectedArea) {
                  this.areaDetailOptions = this.areaDetails.filter(areaDetail => areaDetail.area === selectedArea);
              }
          });
          this.createForm().get('/api/stations/', function(response) {
              _.forEach(response.data, function(each) {
                  this.stations.push(each);
              }.bind(this));
              const selectedAreaDetail = this.areaDetail;
              if (selectedAreaDetail) {
                  this.stationOptions = this.stations.filter(station => station.area_detail === selectedAreaDetail);
              }
          });
      },
      createBaseUrl() {
          let url = `${this.origin}/${this.prefectureNameEn}/`;
          if(this.area && this.areaDetail && this.station) {
              url += `A${this.area}/AD${this.areaDetail}/S${this.station}/`;
          } else if(this.area && this.areaDetail) {
              url += `A${this.area}/AD${this.areaDetail}/`;
          } else if(this.area) {
              url += `A${this.area}/`;
          }
          return url;
        }
    }
}
</script>